import React, { useState, useEffect } from 'react';
import SeedFundSchemeLogo from '../../../images/SeedFundSchemeLogo.svg';
import { BrowserRouter as Router, Route, Link, NavLink } from 'react-router-dom';
import LoginComponent from '../login/LoginComponent';
import ProfileContainer from './ProfileContainer';
import { getSessionStorageValue } from '../../../effects/utils/session-storage';
import { useAuthStateValue } from '../../../providers/AuthStateProvider';
import ApplyNowModalComponent from './ApplyNowModalComponent';

// import GuidelinesFundSchemeStartup from '../../../pdffiles/Guidelines-FundScheme-Startup-29January2021.pdf';

function HeaderComponent() {


    // @ts-ignore: Unreachable code error
    const [{ user }, dispatch] = useAuthStateValue();

    useEffect(() => {
        if (user.accessToken) {
            const overlayElement = document.getElementById('overlay');
            if (!overlayElement) return;

            overlayElement.style.display = 'none';
        }
    }, [user])


    return (
        <header className="app-header">
            <nav className="navbar navbar-expand-lg navbar-dark fixed-top">

                <div className="container-fluid">
                    <Link className="navbar-brand mr-md-auto" to="/">
                        <span aria-label="SISFS Logo" />
                    </Link>

                    {/* @* Hamburger menu code for responsive smaller screens *@ */}
                    <div className="navbar-toggler ml-auto" style={{cursor: "pointer"}} id="ChangeToggle" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                    {/* type="button" */}
                        <div id="navbar-hamburger">
                            <span className="navbar-toggler-icon">
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </span>
                        </div>
                        <div id="navbar-close" className="hidden">
                            {/* <span className="fa fa-close"></span> */}
                            <button type="button" className="close"  aria-label="Close"><span aria-hidden="true">×</span></button>
                        </div>
                    </div>

                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <ul className="navbar-nav m-auto">
                            <li className="nav-item active">
                                {/* <Link role="menuitem" className="nav-link" to="/">Home</Link> */}
                                <NavLink exact={true} className="nav-link" activeClassName='active' to='/home'>Home</NavLink>
                            </li>
                            <li role="none" className="nav-item dropdown">
                                {/* <Link role="menuitem" className="nav-link" to="/about">About</Link> */}
                                {/* <a role="menuitem" className="nav-link">About</a> */}
                                <NavLink exact={true} className="nav-link" activeClassName='active' to='/about'>About</NavLink>

                                <ul className="dropdown-menu">

                                    <li className="dropdown-item">
                                        {/* <Link role="menuitem" to="/about">About Startup India Seed Fund Scheme</Link> */}
                                        <NavLink exact={true} activeClassName='active' to='/about'>About Startup India Seed Fund Scheme</NavLink>
                                        </li>
                                    <li className="dropdown-item">
                                        <a href="https://www.startupindia.gov.in/content/dam/invest-india/Templates/seedfund-gazette.pdf" target="_blank">Gazette Notification <span className="arrow-link">PDF</span></a></li>
                                    <li className="dropdown-item">

                                        <a href="https://dipp.gov.in/sites/default/files/Guidelines-FundScheme-Startup-29January2021.pdf" target="_blank">
                                            Guidelines for Startup India Seed Fund Scheme <span className="arrow-link">PDF</span>
                                        </a>
                                    </li>

                                </ul>
                            </li>

                            <li role="none" className="nav-item">
                                <NavLink exact={true} className="nav-link" activeClassName='active' to='/portfolio'>
                                    Portfolio
                                </NavLink>
                            </li>

                            <li role="none" className="nav-item">
                                {/* <Link role="menuitem" className="nav-link" to="/faq">F.A.Q.</Link> */}
                                <NavLink exact={true} className="nav-link" activeClassName='active' to='/faq'>F.A.Q.</NavLink>
                            </li>
                            <li role="none" className="nav-item">
                                {/* <Link role="menuitem" className="nav-link" to="/contact">Contact</Link> */}
                                <NavLink exact={true} className="nav-link" activeClassName='active' to='/contact'>Contact</NavLink>
                            </li>
                        </ul>

                        <div className="btn-group header-action-section" hidden={user?.accessToken ? true : false}>
                            <button className="btn btn-sisfs btn-transparent-primary" data-toggle="modal" data-target="#LoginCollapse">Login</button>
                            {/* <Link className="btn btn-sisfs btn-transparent-primary" data-toggle="offcanvas" to={ !user.accessToken ? '/login' : '/'} /*onToggle={toggleOffcanvas} /*to="/login">Login</Link> */}

                            <a className="btn btn-sisfs btn-yellow-primary" data-toggle="modal" data-target="#ApplyNowModal">Apply Now</a>
                        </div>

                    </div>

                    {/* <!-- Profile Section --> */}
                    {
                        user.accessToken && <ProfileContainer user={user} />
                    }

                </div>
            </nav>

            {/* Offcanvas for Login screen */}
            {!user.accessToken && < LoginComponent />}
            {/* Offcanvas for Login screen */}

            <ApplyNowModalComponent />
        </header>
    )
}

export default HeaderComponent;
